export var ChallengeType;
(function (ChallengeType) {
    ChallengeType["INVITE_PATIENT"] = "INVITE_PATIENT";
    ChallengeType["INVITE_EMPLOYEE"] = "INVITE_EMPLOYEE";
    ChallengeType["COMPLETE_OFFICE_PROFILE"] = "COMPLETE_OFFICE_PROFILE";
    ChallengeType["UPLOAD_PROFILE_PICTURE"] = "UPLOAD_PROFILE_PICTURE";
    ChallengeType["SEND_EXERCISE_PROGRAM"] = "SEND_EXERCISE_PROGRAM";
    ChallengeType["UPLOAD_EXERCISE"] = "UPLOAD_EXERCISE";
    ChallengeType["CREATE_PROGRAM_TEMPLATE"] = "CREATE_PROGRAM_TEMPLATE";
    ChallengeType["LEAD_VIDEO_CALL"] = "LEAD_VIDEO_CALL";
    ChallengeType["APP_PERSONALIZATION"] = "APP_PERSONALIZATION";
})(ChallengeType || (ChallengeType = {}));
//# sourceMappingURL=challenge-type.enum.js.map